import { SINGLETON } from './internals/singleton';
import { Message } from './types';

export const subscribe = function subscribe(
  callback: (msg: Message | void) => never,
): void {
  SINGLETON.MESSAGE_CHANNEL.subscribe(callback);
};
